import React from "react";
import styled from "@emotion/styled";
import {  colors } from '../components/common/mixins.js';

const baseStyles = {
  color: "#FFFFFF",
  backgroundColor: colors.primaryButton,
  position: "relative",
  textDecoration: "none",
  textTransform: "capitalize",
  fontFamily: "pf_highway_sans_pro_mediumRg",
  borderRadius: "24px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  border: "none",
  "&:hover": {
    backgroundColor: colors.buttonHovered,
    textDecoration: "none !important",
    cursor: "pointer",
  },
};

const StyledButton = styled("a")((props) => ({
  ...baseStyles,
  padding: "16px 24px",
  lineHeight: "16px",
  fontSize: "16px",

  ...(props.isSticky && {
    padding: "8px 16px",
    marginTop: "10px",
    marginBottom: "8px",
    fontSize: "14px",
    lineHeight: "14px",
  }),

  ...(props.isBottom && {
    width: "100%",
  }),
}));

const SubmitBtn = ({
  toDoOnClick,
  venueSeatsProp,
  isSticky = false,
  isBottom = false,
  buttonText,
}) => {
  const onButtonClick = () => {
    const inactiveButton = document.querySelector(
      '[id$="bookButtonsDiv"] .eb-button--disabled'
    );

    if (venueSeatsProp && venueSeatsProp !== (null || undefined)) {
      const hasActiveButton =
        !venueSeatsProp.soldOut &&
        !venueSeatsProp.isBookingInactive &&
        !inactiveButton;

      if (hasActiveButton) {
        if (venueSeatsProp.hasNumberedSeats) {
          toDoOnClick();
          document
            .querySelector(
              ".bookingpanelcontainer .eb-button.eb-button--primary"
            )
            .click();
        } else {
          window.bookingPanel.setEvent(
            document.querySelector(
              ".bookingpanelcontainer .eb-button.eb-button--primary"
            )
          );
        }
      } else {
        toDoOnClick();
      }
    } else {
      toDoOnClick();
    }
  };

  return (
    <StyledButton
      onClick={() => onButtonClick()}
      isSticky={isSticky}
      isBottom={isBottom}
    >
      <div>{buttonText}</div>
    </StyledButton>
  );
};

export default SubmitBtn;
